import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const DiscountIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1192 29.75L4.25 15.8809V18.7142C4.25 19.465 4.5475 20.1875 5.08583 20.7117L16.1217 31.7475C17.2267 32.8525 19.0258 32.8525 20.1308 31.7475L28.9283 22.95C30.0333 21.845 30.0333 20.0459 28.9283 18.9409L18.1192 29.75Z"
        fill="currentColor"
      />
      <path
        d="M16.1217 24.6642C16.6742 25.2167 17.3967 25.5 18.1192 25.5C18.8417 25.5 19.5642 25.2167 20.1167 24.6642L28.9142 15.8667C30.0192 14.7617 30.0192 12.9625 28.9142 11.8575L17.8783 0.821667C17.3542 0.2975 16.6317 0 15.8808 0H7.08333C5.525 0 4.25 1.275 4.25 2.83333V11.6308C4.25 12.3817 4.5475 13.1042 5.08583 13.6283L16.1217 24.6642ZM7.08333 2.83333H15.8808L26.9167 13.8692L18.1192 22.6667L7.08333 11.6308V2.83333Z"
        fill="currentColor"
      />
      <path
        d="M10.2708 7.79167C11.2488 7.79167 12.0417 6.99884 12.0417 6.02083C12.0417 5.04283 11.2488 4.25 10.2708 4.25C9.29283 4.25 8.5 5.04283 8.5 6.02083C8.5 6.99884 9.29283 7.79167 10.2708 7.79167Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default DiscountIcon;

DiscountIcon.propTypes = customIconsPropTypes;
